import { render, staticRenderFns } from "./WatchersTab.vue?vue&type=template&id=64babfbf&scoped=true"
import script from "./WatchersTab.vue?vue&type=script&lang=js"
export * from "./WatchersTab.vue?vue&type=script&lang=js"
import style0 from "./WatchersTab.vue?vue&type=style&index=0&id=64babfbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64babfbf",
  null
  
)

export default component.exports